import BackArrowIcon from 'components/elements/icons/BackArrowIcon'
import WrappedTelIcon from 'components/elements/icons/WrappedTelIcon'
import CallModal from 'components/elements/modal/CallModal'
import TextTitle from 'components/elements/texts/TextTitle'
import { HistoryStackContext } from 'contexts/HistoryStackContext'
import React, { useCallback, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import { transitionWithAction } from 'utils/commonUtils'
import { StatusProps } from 'utils/status'

/**
 * 画面上部のヘッダー表示エリア
 */
const HeaderArea: React.FC<HeaderAreaProps> = (props) => {
  const history = useHistory()
  const historyStackContext = useContext(HistoryStackContext)

  const goBack = useCallback(async (): Promise<StatusProps> => {
    return await transitionWithAction(
      historyStackContext,
      'ヘッダー戻るボタン',
      () => {
        props.backTo ? history.push(props.backTo) : history.goBack()
      },
      props.backAction
    )
  }, [props.backAction, props.backTo])

  return (
    <StyledHeaderArea>
      {props.showBack ? (
        <LeftArea onClick={goBack}>
          <BackArrowIcon color="var(--color-main)" />
        </LeftArea>
      ) : (
        <LeftArea />
      )}
      <CenterArea>
        <HeaderTitle color="var(--color-text)">{props.title}</HeaderTitle>
      </CenterArea>
      <RightArea>
        {props.showContact && (
          <CallModal isTransitionReAccess>
            <WrappedTelIcon />
          </CallModal>
        )}
      </RightArea>
    </StyledHeaderArea>
  )
}

export type HeaderAreaProps = {
  title: string
  showContact?: boolean
  showBack?: boolean
  backAction?: () => StatusProps | Promise<StatusProps>
  backTo?: string
}

const StyledHeaderArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 64px;
  background: var(--color-content-background);
  border-bottom: 0.5px solid var(--color-border);
`

const LeftArea = styled.div`
  display: flex;
  align-items: center;
  width: 44px;
  margin-left: 8px;
`

const CenterArea = styled.div`
  flex: 1;
`

const HeaderTitle = styled(TextTitle)`
  font-size: 17px;
`

const RightArea = styled.div`
  width: 44px;
  margin-right: 8px;
`

export default HeaderArea
